import { useState } from "react";
import CandidateDataManagement from './CandidateDataManagement';
import commonEnLabels from '../../common/labels/common_en.json';
import { isAuthorized } from '../../helpers/AuthUtils';
import { shallowEqual, useSelector } from 'react-redux';
export default function CandidateManagement() {
    return (
        <div>
            <Tabs />
        </div>
    )
}

const Tabs = () => {
    const { authData } = useSelector(state => state.loginReducer, shallowEqual);
    let deptRoles = authData && authData.deptRoles && authData.deptRoles[0] && authData.deptRoles[0].roleId;
    const hasCreateMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "CANDIDATE_MGMT", "C");
    const hasReadMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "CANDIDATE_MGMT", "R");
    const hasUpdateMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "CANDIDATE_MGMT", "U");
    const hasDeletMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "CANDIDATE_MGMT", "D");
    const headerField = ['Check Eligibility', 'Re-Check Eligibility', 'Application Profile', 'Candidate Profile']
    const [stepName, setName] = useState(1);
    return (
        authData &&
        <div className="px-2">
            { (hasCreateMasterPermission || hasReadMasterPermission || hasUpdateMasterPermission || hasDeletMasterPermission) == true ?
             <>
                <div className="table-responsive-lg px-4 py-2">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        {headerField && headerField.map((element, index) =>
                            <li className="nav-item" key={index} role="button" >
                                <a className={stepName === index+1 ? "nav-link active" : "nav-link bg-profile-tabs"} value="home" id="home-tab" data-toggle="tab" role="tab" onClick={() => { setName(index+1); }} aria-controls="home" aria-selected="false">
                                    <span>{element}</span>
                                </a>
                            </li>
                        )}
                    </ul>
                    <div className="tab-content border border-light candidateMTable" id="myTabContent">
                                <div className={stepName === 1 ? "tab-pane fade show active backgroundCss" : "tab-pane fade backgroundCss boxShadow"} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <CandidateDataManagement
                                        isTab={stepName}
                                    />
                                </div>
                                <div className={stepName === 2 ? "tab-pane fade show active backgroundCss" : "tab-pane fade backgroundCss"} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <CandidateDataManagement
                                        isTab={stepName}
                                    />
                                </div>
                                <div className={stepName === 3 ? "tab-pane fade show active backgroundCss" : "tab-pane fade backgroundCss"} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <CandidateDataManagement
                                        isTab={stepName}
                                    />
                                </div>
                                <div className={stepName === 4 ? "tab-pane fade show active backgroundCss" : "tab-pane fade backgroundCss"} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <CandidateDataManagement
                                        isTab={stepName}
                                    />
                                </div>
                </div>
            </div>
            </>
            : 
                <div className="premium-permission-box">
                    <h1>{commonEnLabels.COMMON.ACCESS_DENIED}</h1>
                </div>
            }
        </div>
    )
}